import React, { useState, useEffect, useCallback } from 'react';
import { AtSign, Trash2, Download } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

export default function NewsletterManager() {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSubs = useCallback(() => {
    api.get('/newsletter').then(r => setSubs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { fetchSubs(); }, [fetchSubs]);

  const handleDelete = async (id) => {
    if (!window.confirm('Bu aboneyi silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete(`/newsletter/${id}`);
      toast.success('Abone silindi');
      fetchSubs();
    } catch (err) {
      toast.error('Silme hatası');
    }
  };

  const handleExport = () => {
    if (subs.length === 0) return;
    const header = 'E-posta,Kayıt Tarihi\n';
    const rows = subs.map(s => `${s.email},${new Date(s.created_at).toLocaleString('tr-TR')}`).join('\n');
    const blob = new Blob([header + rows], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'bulten-aboneleri.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter-manager">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="font-heading text-2xl font-semibold">Bülten Aboneleri</h1>
          <p className="text-sm text-muted-foreground mt-1">Toplam {subs.length} abone</p>
        </div>
        <button
          onClick={handleExport}
          disabled={subs.length === 0}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="newsletter-export-button"
        >
          <Download className="w-4 h-4" /> CSV İndir
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-10"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>
      ) : subs.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          <AtSign className="w-10 h-10 mx-auto mb-3 opacity-40" />
          Henüz bülten abonesi yok
        </div>
      ) : (
        <div className="space-y-2">
          {subs.map(sub => (
            <div key={sub.id} className="flex items-center gap-4 p-4 rounded-xl border border-border bg-card hover:bg-secondary transition-colors" data-testid="newsletter-row">
              <div className="w-8 h-8 rounded-full bg-[hsl(var(--gold)/0.1)] flex items-center justify-center shrink-0">
                <AtSign className="w-4 h-4 text-[hsl(var(--gold))]" />
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium break-all">{sub.email}</span>
              </div>
              <span className="text-xs text-muted-foreground shrink-0">{new Date(sub.created_at).toLocaleDateString('tr-TR')}</span>
              <button onClick={() => handleDelete(sub.id)} className="p-1.5 rounded-lg hover:bg-destructive/10 text-destructive shrink-0" data-testid="newsletter-delete-button">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
